import React from 'react'

import { useFormContext } from 'react-hook-form'
import cx from 'classnames'

import { FlexTableCell, FlexTableRow } from 'common/FlexTable'
import { formatCurrency, formatNumber } from 'utils/formatters'
import { useStores } from 'stores'
import ReadOnlyField from 'common/ReadOnlyField'

import CartTableTransportTresholds from 'components/Webshop/WebshopCart/CartItems/CartTableTransportTresholds'

export default ({ resource, isStripe }) => {
  const { watch } = useFormContext()
  const { webshopCartStore } = useStores()

  const transport = watch('transport')

  const {
    Lookups: { data: { categories = [] } = {} },
  } = webshopCartStore

  const categoryName = React.useMemo(() => {
    return (transport?.categoryCode && categories.find(item => item.code === transport.categoryCode)?.name) || ''
  }, [categories, transport])

  if (!transport) return null

  return (
    <React.Fragment>
      <FlexTableRow className={cx('transport border-0 pt-3', isStripe && 'table-striped-bg')}>
        <FlexTableCell className="col-xl-action col-auto align-items-start px-0 d-none d-xl-flex" />
        <FlexTableCell className="col align-items-start fw-bold fs-12 pb-xl-0">
          {resource.Transport}
        </FlexTableCell>
        <FlexTableCell className="d-flex align-items-start col-xl-2 col-12 fs-12 pb-xl-0">
          <span className="d-xl-none d-inline-block col-sm-4 col-6 fw-bold me-2">{resource.Quantity}:</span>
          <span>{formatNumber(1)}</span>
        </FlexTableCell>
        <FlexTableCell className="d-flex align-items-start justify-content-xl-end col-xl-2 col-12 fs-12 pb-xl-0">
          <span className="d-xl-none d-inline-block col-sm-4 col-6 fw-bold me-2">{resource.PriceWithouVat}:</span>
          <span>{formatCurrency(transport.amount, undefined, '€')}</span>
        </FlexTableCell>
        <FlexTableCell className="d-flex align-items-start justify-content-xl-end col-xl-2 col-12 fs-12 pb-xl-0">
          <span className="d-xl-none d-inline-block col-sm-4 col-6 fw-bold me-2">{resource.SubtotalWithoutVat}:</span>
          <span>{formatCurrency(transport.amount, undefined, '€')}</span>
        </FlexTableCell>
      </FlexTableRow>
      <FlexTableRow className={cx('transport', isStripe && 'table-striped-bg')}>
        <FlexTableCell className="col-action d-xl-flex d-none" />
        <FlexTableCell className="align-items-start col-xl col-12 d-block pt-xl-0 pb-xl-2 pb-0">
          <ReadOnlyField
            value={categoryName}
            formGroup
            className="form-control"
            formClassName="col-xl-6 col-sm-2 col-2"
          />
          <ReadOnlyField
            value={transport?.subCategoryCode || ''}
            formGroup
            className="form-control"
            formClassName="col-xl-6 col-sm-2 col-2"
            disabled={!transport?.subCategoryCode}
          />
          <CartTableTransportTresholds transport={transport} resource={resource} />
        </FlexTableCell> 
      </FlexTableRow>
    </React.Fragment>
  )
}
